<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="430">
      <v-card class="pa-6 block-modal-card">
        <v-card-title class="pa-0 pb-7">
          <v-row no-gutters>
            <v-col cols="11">
              <h3 class="block-modal-card__title">Заблокировать регистратора</h3>
            </v-col>
            <v-col cols="1">
              <v-btn icon @click="closeHandler">
                <v-icon large color="black">close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="px-0">
          <v-col class="pa-0 pb-3">
            <span class="block-modal-card__info">{{ item.organizationInn }}</span>
            <span class="block-modal-card__info pb-4">{{ item.organizationName }}</span>
            <span class="block-modal-card__info">{{ item.personalInn }}</span>
            <span class="block-modal-card__info pb-4">{{ item.fullName }}</span>
            <span class="block-modal-card__date">
              Сертификат активен до {{ moment.unix(item.validUntil).format('LL') }}
            </span>
          </v-col>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-row justify="center">
            <v-btn
              dark
              large
              class="text-capitalize mb-2"
              width="205"
              rounded
              outlined
              color="#ff0000"
              @click.prevent="blockHandler"
            >
              Заблокировать
            </v-btn>
            <v-btn text large rounded width="205" class="text-capitalize" @click.prevent="closeHandler">
              Отменить
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'BlockModal',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    item: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  methods: {
    closeHandler() {
      this.$emit('close-block-modal', false)
    },
    blockHandler() {}
  }
}
</script>

<style lang="scss" scoped>
.block-modal-card {
  &__title {
    font-weight: 600;
    font-size: 32px;
    color: #000;
    padding-right: 90px;
  }
  &__info {
    font-weight: 400;
    font-size: 16px;
    color: #000;
    display: block;
  }
  &__date {
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: rgba(51, 51, 51, 0.54);
  }
}
</style>
